import styled from "styled-components";

export const StyledExchangeWrapper = styled.div`
  .tab-body {
    @media screen and (max-width: 992px) {
      padding: 0;
      border: none;
      border-radius: 0;
      box-shadow: none;
    }
  }
`;

export const StyledExchangeHistoryWrapper = styled.div`
  .exchange-history-head {
    padding: 15px 0 25px;
    display: grid;
    align-items: center;
    grid-template-columns: max-content 175px 1fr;
    grid-gap: 20px;

    &__create {
      display: inline-grid;
      align-items: center;
      justify-content:  end;
      grid-template-rows: 45px;
      button {
        height: 100%;
      }
    }
    @media screen and (max-width: 768px) {
      grid-template-columns: 100%;
      &__create {
        justify-content: start;
      }
    }
  }
  
  .exchange-table_scroll {
    @media screen and (max-width: 992px) {
      overflow: inherit;
    }
  }

  .exchange-table {
    &__head,
    &__row {
      grid-template-columns: minmax(250px, .85fr) repeat(6, 1fr);
    }

    &_admin {
      &__head,
      &__row {
        grid-template-columns: repeat(2, minmax(250px, .85fr)) repeat(6, 1fr);
      }
    }

    @media screen and (max-width: 992px) {
      min-width: auto;
      overflow-x: inherit;
      &__head {
        display: none;
      }

      &__head, &__row {
        margin-bottom: 15px;
        grid-template-columns: repeat(2, 50%);
        border: 1px solid ${({theme}) => theme.surface.border};

        & > div {
          padding-top: 20px;

          &:before {
            display: block;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    @media screen and (max-width: 599px) {
      &__row {
        padding: 15px 10px;
        grid-template-columns: 100%;
      }
    }
  }
`;

export const StyledExchangeHistoryDetailsWrapper = styled.div`
  .exchange-history-details-head {
    padding: 15px 0 25px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    .icon-light-reload {
      padding-right: 10px;
      font-weight: 700;
    }

    a, button {
      height: 45px;
    }
  }
  
  .exchange-history-details {
    &__block {
      grid-template-columns: 20% 80%;
    }
    &__head {
      padding: 0 25px 20px;
    }
    &__row {
      grid-template-columns: repeat(2, 50%);
      & > div {
        padding: 0;
        margin: 0;
        &:before {
          display: none;
        }
        &:last-child {
          display: inline-flex;
          p {
            width: 100%;
            text-align: left;
            overflow-wrap: break-word;
          }
        }
      }
    }
    .icon-light-copy {
      cursor: pointer;
    }

    @media screen and (max-width: 1920px) {
      max-width:  inherit;
    }
    @media screen and (max-width: 992px) {
      &__block {
        grid-template-columns: 100%;
      }
    }
    @media screen and (max-width: 576px) {
      &__row {
        padding: 15px 0;
        grid-template-columns: 100%;
        & > div:first-child {
          padding-bottom: 10px;
          color: ${({theme}) => theme.text.primary};
          font-weight: 600;
        }
      }
    }
  }
`;